import { http } from "./http";

/**
 * Annuaire des photos de l'école courante : identifiant → adresse de la photo (versionnée).
 * Seuls les élèves et les moniteurs qui ont une photo y figurent ; les autres gardent leurs
 * initiales.
 */
export type PhotoDirectory = {
  /** Élèves, par identifiant de fiche élève. */
  candidates: Record<string, string>;
  /** Comptes de l'équipe (messagerie, en-tête), par identifiant de compte. */
  staff: Record<string, string>;
  /** Moniteurs du planning, par identifiant de planning. */
  instructors: Record<string, string>;
};

const multipart = (file: Blob, name: string) => {
  const form = new FormData();
  form.append("file", file, name);
  return form;
};
const MULTIPART = { headers: { "Content-Type": "multipart/form-data" } };

export const photosApi = {
  directory: async (): Promise<unknown> => {
    const { data } = await http.get<unknown>("/v1/photos");
    return data;
  },

  /** Pose ou remplace la photo d'un élève ; renvoie l'adresse de la nouvelle photo. */
  uploadCandidate: async (candidateId: string, file: Blob) => {
    const { data } = await http.post<{ photoUrl: string | null }>(
      `/v1/candidate-photos/${candidateId}`,
      multipart(file, "photo.jpg"),
      MULTIPART,
    );
    return data;
  },

  removeCandidate: async (candidateId: string) => {
    const { data } = await http.delete<{ photoUrl: string | null }>(
      `/v1/candidate-photos/${candidateId}`,
    );
    return data;
  },

  /** Ma photo : celle de ma fiche d'équipe (reliée à mon compte par mon adresse e-mail). */
  uploadMine: async (file: Blob) => {
    const { data } = await http.post<{ photoUrl: string | null }>(
      "/v1/team/me/photo",
      multipart(file, "photo.jpg"),
      MULTIPART,
    );
    return data;
  },

  removeMine: async () => {
    const { data } = await http.delete<{ photoUrl: string | null }>(
      "/v1/team/me/photo",
    );
    return data;
  },
};
